import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TableCell } from '@mui/material';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { fNumber } from '../../../../../utils/formatNumber';
import modifyScriptName from '../../../../../utils/modifyScriptName';
import PriceWithColor from '../PriceWithColor';
import { StyledTableRow, PriceBox, ChangeBox } from './StyledComponents';

const DesktopWatchListRow = ({ item, onClick }) => {
  const quotesData = useSelector((state) => state?.trade?.quotesData[item?.instrument_token]);
  // Format the symbol name with expiry details including day and month
  const formattedSymbolName = modifyScriptName(item.tradingsymbol, item.expiry);
  return (<StyledTableRow
    onClick={() => onClick(item)}
    sx={{
      cursor: 'pointer',
      transition: theme => theme.transitions.create(['background-color'], {
        duration: theme.transitions.duration.shorter,
      }),
      mb: 1.5, // Increased margin bottom for each row
    }}
  >
    <TableCell component="th" scope="row">
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 600, textTransform: 'uppercase' }} noWrap>
          {formattedSymbolName}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
          <Typography variant="caption" sx={{ fontSize: 11, color: 'text.secondary' }}>
            H: {fNumber(quotesData?.ohlc?.high || 0)}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: 11, color: 'text.secondary' }}>
            L: {fNumber(quotesData?.ohlc?.low || 0)}
          </Typography>
        </Box>
      </Box>
    </TableCell>
    <TableCell align="right">
      <PriceBox>
        <PriceWithColor
          price={+(quotesData?.depth?.buy?.[0]?.price || 0).toFixed(2)}
          variant="subtitle2"
          color="up"
        />
      </PriceBox>
    </TableCell>
    <TableCell align="right">
      <PriceBox>
        <PriceWithColor
          price={+(quotesData?.depth?.sell?.[0]?.price || 0).toFixed(2)}
          variant="subtitle2"
          color="down"
        />
      </PriceBox>
    </TableCell>
    <TableCell align="right">
      <Typography variant="body2" sx={{ fontSize: 12, fontWeight: 500 }}>
        {fNumber(quotesData?.last_price || 0)}
      </Typography>
    </TableCell>
    <TableCell align="right">
      <ChangeBox isPositive={+(quotesData?.chg || 0) >= 0}>
        <Icon
          icon={+(quotesData?.chg || 0) >= 0 ? 'mdi:trending-up' : 'mdi:trending-down'}
          width={14}
        />
        {(quotesData?.chg || 0) < 0 ? '' : '+'}
        {fNumber(+(quotesData?.chg || 0).toFixed(2))}
      </ChangeBox>
    </TableCell>
  </StyledTableRow>
  );
};

DesktopWatchListRow.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default DesktopWatchListRow;
